import { useState } from "react";
import { NO_RESPONSE_ERROR_CODES, TICKET_NOT_CREATED_ERROR } from "./ticketFormConfig";

// What the customer sees when sending fails: the "ticket not opened" dialog when the ticket
// wasn't opened or no answer came back, and any other error (e.g. a duplicate ticket within
// 24 hours) as a snackbar
export const useSubmitFeedback = (setSnackbar) => {
  const [ticketNotCreatedOpen, setTicketNotCreatedOpen] = useState(false);

  const handleSubmitError = (error) => {
    if (error.code === TICKET_NOT_CREATED_ERROR || NO_RESPONSE_ERROR_CODES.includes(error.code)) {
      setTicketNotCreatedOpen(true);
    } else {
      setSnackbar({
        open: true,
        message: error.message || "שגיאה בשליחת הקריאה",
        severity: "error",
      });
    }
  };

  return {
    ticketNotCreatedOpen,
    closeTicketNotCreated: () => setTicketNotCreatedOpen(false),
    handleSubmitError,
  };
};
